<template lang="pug">
//- The three answers to "does this time bill?": yes, no, and not decided yet.
//- The third is NULL on the entry ("Prüfen"): it bills nothing until somebody
//- picks one of the other two, and the team and billing screens count it so
//- it does get picked. One control for every dialog that asks.
div
    el-radio-group(:value="state" size="mini" @input="onInput")
        el-radio-button(label="yes") {{ $t('Billable') }}
        el-radio-button(label="no") {{ $t('Not billable') }}
        el-radio-button(label="check") {{ $t('To check') }}
    p.help(v-if="!compact") {{ hint }}
</template>

<i18n>
{
    "de": {
        "Billable": "Abrechenbar",
        "Not billable": "Nicht abrechenbar",
        "To check": "Prüfen",
        "Counts towards the customer invoice.": "Wird dem Kunden in Rechnung gestellt.",
        "Recorded on the ticket, not billed.": "Wird am Ticket vermerkt, aber nicht berechnet.",
        "Bills nothing until somebody decides. Listed under To check on the team and billing screens.": "Wird erst berechnet, wenn jemand entscheidet. Erscheint unter Zu prüfen im Team und in der Abrechnung."
    }
}
</i18n>

<script>
const STATES = { yes: true, no: false, check: null };

export default {
    name: 'BillableStateSelect',
    props: {
        // true, false or null; null is "Prüfen".
        value: { type: Boolean, default: true },
        // Buttons only, where the state is legible on its own and the
        // explanation would crowd the line it sits in.
        compact: { type: Boolean, default: false },
    },
    computed: {
        state() {
            return Object.keys(STATES).find((key) => STATES[key] === this.value) || 'check';
        },
        hint() {
            if (this.value === true) return this.$t('Counts towards the customer invoice.');
            if (this.value === false) return this.$t('Recorded on the ticket, not billed.');

            return this.$t('Bills nothing until somebody decides. Listed under To check on the team and billing screens.');
        },
    },
    methods: {
        onInput(state) {
            this.$emit('input', STATES[state]);
        },
    },
};
</script>

<style lang="sass" scoped>
.help
    margin: 0.25rem 0 0
    line-height: 1.4
</style>
